import {
  IconArchive,
  IconClipboard,
  IconPlayerPause,
  IconRocket,
  IconSpeakerphone,
} from "@tabler/icons-react";
import { useMemo } from "react";
import { useLanguage } from "../../../../stores/LanguageStore";
import { Center, Divider, Group, SegmentedControl } from "@mantine/core";
import { useNavigate, useParams } from "react-router-dom";

const CampaignFilter = () => {
  const lang = useLanguage((s) => s.language);
  const { filter } = useParams();
  const navigate = useNavigate();

  const onChange = (v) => {
    navigate(`/statistics/campaigns/${v}`);
  };

  const filters = useMemo(() => {
    return [
      {
        value: "running",
        label: (
          <Center style={{ gap: 6 }}>
            <IconRocket size={18} />
            <span style={{fontSize: 10}}>{lang.statistics.filters.running}</span>
          </Center>
        ),
        color: "#0a0",
      },
      {
        value: "stopped",
        label: (
          <Center style={{ gap: 6 }}>
            <IconPlayerPause size={18} />
            <span style={{fontSize: 10}}>{lang.statistics.filters.paused}</span>
          </Center>
        ),
        color: "yellow",
      },
      {
        value: "archived",
        label: (
          <Center style={{ gap: 6 }}>
            <IconArchive size={18} />
            <span style={{fontSize: 10}}>{lang.statistics.filters.archived}</span>
          </Center>
        ),
        color: "purple",
      },
      {
        value: "all",
        label: (
          <Center style={{ gap: 6 }}>
            <IconSpeakerphone size={18} />
            <span style={{fontSize: 10}}>{lang.statistics.filters.all}</span>
          </Center>
        ),
      },
    ];
  }, [lang]);

  return (
    <Group pos={"relative"} style={{ zIndex: 100 }}>
      <SegmentedControl
        radius={"md"}
        onChange={onChange}
        size="md"
        value={filter || "workflows"}
        bg={"#fcfbff"}
        color="#e9dcff"
        pos={"relative"}
        style={{
          border: "1px solid #e9dcff",
          color: "#000",
          zIndex: 8,
        }}
        styles={{
          label: {
            color: "#000",
          },
        }}
        data={[
          {
            value: "workflows",
            label: (
              <Center style={{ gap: 6 }}>
                <IconClipboard size={18} />
                <span style={{fontSize: 10}}>{lang.workflows.browser_tab_title_listing}</span>
              </Center>
            ),
            color: "primary",
          },
        ]}
      />

      <SegmentedControl
        radius={"md"}
        onChange={onChange}
        size="md"
        value={filter || "workflows"}
        data={filters}
        bg={"#fcfbff"}
        color="#e9dcff"
        style={{
          border: "1px solid #e9dcff",
          color: "#000",
        }}
        styles={{
          label: {
            color: "#000",
          },
        }}
      />
    </Group>
  );
};

export default CampaignFilter;
